import { commitMutation, graphql } from 'react-relay/legacy';

const mutation = graphql`
    mutation changeDisplayPreferrencesMutation($input: EditPersonalProfileInput!) {
        editPersonalProfile(input: $input) {
            user {
                preferences {
                    currency
                    preferredLocale
                }
            }
        }
    }
`;

const getOptimisticResponse = (id, currency, preferredLocale) => ({
    editPersonalProfile: {
        user: {
            id,
            preferences: {
                currency,
                preferredLocale,
            },
        },
    },
});

export function changeDisplayPreferrencesMutation({
    environment,
    user,
    currency,
    preferredLocale,
    onCompleted,
}) {
    const { id, serviceId } = user;

    return commitMutation(environment, {
        mutation,
        variables: {
            input: {
                userServiceId: serviceId,
                currency,
                preferredLocale,
            },
        },
        optimisticResponse: getOptimisticResponse(id, currency, preferredLocale),
        onCompleted,
    });
}
